import * as yup from 'yup';

export type StageRange = { dasFrom?: number; dasTo?: number };
export type StageRanges = Record<string, StageRange>;

const WHOLE_NUMBER = /^-?\d+$/;

const toNumber = (value?: string) => {
  const text = (value ?? '').trim();
  return text === '' ? NaN : Number(text);
};

const outOfRange = (value: number, range?: StageRange) => {
  if (!range || Number.isNaN(value)) return undefined;
  const { dasFrom, dasTo } = range;
  if (dasFrom != null && dasTo != null && (value < dasFrom || value > dasTo)) {
    return `Must be between ${dasFrom} and ${dasTo}`;
  }
  if (dasFrom != null && value < dasFrom) {
    return `Must be ${dasFrom} or more`;
  }
  if (dasTo != null && value > dasTo) {
    return `Must be ${dasTo} or less`;
  }
  return undefined;
};

export const buildLineSchema = (productRequired: boolean) =>
  yup.object({
    product: productRequired
      ? yup.string().required('Product is required')
      : yup.string(),
    stage: yup.string().required('Stage is required'),
    dasFrom: yup
      .string()
      .required('DAS From is required')
      .matches(WHOLE_NUMBER, 'Enter a whole number')
      .test('stage-range', function (value) {
        const ranges: StageRanges | undefined =
          this.options.context?.stageRanges;
        const message = outOfRange(
          toNumber(value),
          ranges?.[this.parent.stage]
        );
        return message ? this.createError({ message }) : true;
      }),
    dasTo: yup
      .string()
      .required('DAS To is required')
      .matches(WHOLE_NUMBER, 'Enter a whole number')
      .test('stage-range', function (value) {
        const ranges: StageRanges | undefined =
          this.options.context?.stageRanges;
        const to = toNumber(value);
        const from = toNumber(this.parent.dasFrom);
        const message = outOfRange(to, ranges?.[this.parent.stage]);
        if (message) return this.createError({ message });
        if (!Number.isNaN(to) && !Number.isNaN(from) && to < from) {
          return this.createError({
            message: 'Must be at least DAS From',
          });
        }
        return true;
      }),
    mandatory: yup.string().required('Mandatory is required'),
  });
